export default __webpack_public_path__ + "static/media/Screenshot (26).9f74ad44.png";